// extracted by mini-css-extract-plugin
export default {"modalContent":"create-folder_modalContent__-1p6M"};